import { Configuration, PopupRequest } from '@azure/msal-browser';

export const scopes = [process.env.REACT_APP_MSAL_SCOPE as string];

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID as string,
    authority: process.env.REACT_APP_MSAL_AUTHORITY,
    knownAuthorities: [process.env.REACT_APP_MSAL_KNOWN_AUTHORITY as string], // array of URIs that are known to be valid
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  // system: {
  // loggerOptions: {
  // loggerCallback: (level, message, containsPii) => {
  //     if (containsPii) {
  //         return;
  //     }
  //     switch (level) {
  //         case LogLevel.Error:
  //             console.error(message);
  //             return;
  //         case LogLevel.Info:
  //             console.info(message);
  //             return;
  //         case LogLevel.Verbose:
  //             console.debug(message);
  //             return;
  //         case LogLevel.Warning:
  //             console.warn(message);
  //             return;
  //     }
  // }
  // }
  // }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['openid'],
};
